

















import { defineComponent, computed } from '@vue/composition-api'
import useAppConfig from '@core/@app-config/useAppConfig'
import { useRouter } from '@core/utils'
import { useLayout } from '@core/layouts/composable/useLayout'

// Layouts
import Loading from 'vue-loading-overlay'
import LayoutContentVerticalNav from '@/layouts/variants/content/LayoutContentVerticalNav.vue'
import LayoutBlank from '@/layouts/variants/blank/LayoutBlank.vue'

// Dynamic vh
import useDynamicVh from '@core/utils/useDynamicVh'

// Config
import themeConfig from '@themeConfig'

export default defineComponent({
  components: {
    Loading,
    LayoutContentVerticalNav,
    LayoutBlank,
  },
  setup() {
    const { route } = useRouter()
    const { appContentLayoutNav, appSkinVariant, appRouteTransition } = useAppConfig()
    const { isDark, isLoading } = useAppConfig()
    const color = computed(() => {
      return isDark ? themeConfig.themes.dark.primary : themeConfig.themes.light.primary
    })

    const { handleBreakpointLayoutSwitch } = useLayout()
    handleBreakpointLayoutSwitch()

    const resolveLayoutVariant = computed(() => {
      if (route?.value?.meta?.layout === 'blank') return 'layout-blank'
      if (route?.value?.meta?.layout === 'content') return `layout-content-${appContentLayoutNav.value}-nav`

      return null
    })

    useDynamicVh()

    return {
      isLoading,
      color,
      resolveLayoutVariant,
      appSkinVariant,
      appRouteTransition,
    }
  },
})
